import { CarrierRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class CarrierService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new CarrierRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	authorizeStamps() {
		var url = this.routeService.authorizeStamps();
		return this.apiClient.post(url);
	}

	authorizationResultStamps() {
		var url = this.routeService.authorizationResultStamps();
		return this.apiClient.get(url);
	}

	authorizeUps() {
		var url = this.routeService.authorizeUps();
		return this.apiClient.post(url);
	}

	authorizationResultUps() {
		var url = this.routeService.authorizationResultUps();
		return this.apiClient.get(url);
	}
}

export default CarrierService;



// WEBPACK FOOTER //
// ./src/common/data/services/CarrierService.js